import axios from "axios";
import Vue from "vue";

// YTP-10380 Gise kullanici bazli menu/gorunum ayarlari (managementconsole /user-ui-settings).
// Tek ham ayar objesi tutulur; alt bolumler (homeView, favorites, quickMenu, sidebar) getter'larla servis edilir.
// environment parametresi global axios default'undan otomatik eklenir (store.js).
export default {
  state: () => ({
    uiSettings: {},
    uiSettingsLoaded: false,
  }),

  mutations: {
    setUiSettings(state, settings) {
      Vue.set(state, "uiSettings", settings || {});
      Vue.set(state, "uiSettingsLoaded", true);
    },
  },

  actions: {
    // App init'te bir kez cagrilir
    loadUiSettings(context) {
      return axios
        .get(context.getters.getMcServiceUrl + "/user-ui-settings")
        .then((response) => {
          context.commit("setUiSettings", response.data || {});
          return response.data;
        })
        .catch((err) => {
          // Ayar okunamazsa bos ile devam et (ozellik varsayilan davranisa duser)
          context.commit("setUiSettings", {});
          return err.response;
        });
    },

    // Kismi guncelleme: mevcut ayarin uzerine merge edip tam objeyi kaydeder (optimistic)
    saveUiSettings(context, partial) {
      const merged = { ...(context.getters.getUiSettings || {}), ...(partial || {}) };
      context.commit("setUiSettings", merged);
      return axios
        .put(context.getters.getMcServiceUrl + "/user-ui-settings", merged)
        .then((response) => response)
        .catch((err) => err.response);
    },
  },

  getters: {
    getUiSettings: (state) => state.uiSettings,
    getUiHomeView: (state) => state.uiSettings.homeView || {},
    getUiFavorites: (state) => state.uiSettings.favorites || [],
    getUiQuickMenu: (state) => state.uiSettings.quickMenu || [],
    getUiSidebar: (state) => state.uiSettings.sidebar || {},
    isUiSettingsLoaded: (state) => state.uiSettingsLoaded,
  },
};
